import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class QuickAddCheckboxService {
  private _isChecked: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public isChecked$: Observable<boolean> = this._isChecked.asObservable();

  constructor() {};
  public setCheckboxState(state:boolean) {
    this._isChecked.next(state);
  }
}
